module.exports = __webpack_public_path__ + "static/img/tapPay.92aa3b6b.png";